import { render, staticRenderFns } from "./AddRatePlan.vue?vue&type=template&id=10fd4371&scoped=true&"
import script from "./AddRatePlan.vue?vue&type=script&lang=js&"
export * from "./AddRatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd4371",
  null
  
)

export default component.exports